module.exports = __webpack_public_path__ + "static/computer-ce82adb9deda81e68e8ef24ebce349f9.png";